import * as React from 'react';
import DatePicker from "react-datepicker";

interface DateProps {
    date: {
        from: Date,
        to: Date
    },
    onDateChange: (type: string, change: Date) => void
}

export const FilterDate: React.SFC<DateProps> = ({date, onDateChange}) => {
    return (
        <div className="search__filter__container search__filter__container--date">
            <div className="layout__clearfix-container search__date-filter-row search__filter-type-toggle-content">

                <div className="search__date-filter-col">
                    <div className="search__date-filter-col__label">from</div>
                    <div className="search__datepicker-container">
                        <DatePicker wrapperClassName="search__date-filter-col__datepicker" dateFormat="dd/MM/yyyy" selected={date.from} onChange={onDateChange.bind(this, 'from')} />
                    </div>
                </div>

                <div className="search__date-filter-col">
                    <div className="search__date-filter-col__label">to</div>
                    <div className="search__datepicker-container">
                        <DatePicker wrapperClassName="search__date-filter-col__datepicker" dateFormat="dd/MM/yyyy" selected={date.to} onChange={onDateChange.bind(this, 'to')} />
                    </div>
                </div>
                
            </div>

        </div>
    )
}